export default __webpack_public_path__ + "static/media/Tacos.667955b7.jpeg";